import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class SubTaskTemplateMultiSelectListComponent implements IController {
  selectedIds: any;
  optionIds: any;
  excludeIds: any;
  type: any;
  onChange: Function;

  public queryString: any;
  public selectedKeys: any;
  public excludeKeys: any;
  public isSelectAll: boolean;
  public subTasksTemplatesRef: any;
  public subtaskTemplates: any;
  public subtaskTemplatesCopy: any;
  public isLoading: boolean;

  /* @ngInject */
  constructor(private $log, private $subTasksTemplates, private $infiniteScroll, private commonsService: CommonsService) {
  }

  $onInit() {
    this.subTasksTemplatesRef = this.$subTasksTemplates();

    this._getSubtaskTemplates();
  }

  $onChanges(changes) {

    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }

    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }

  }

  private _getSubtaskTemplates() {
    this.isLoading = true;
    this.subTasksTemplatesRef.$getAll({type: this.type})
      .then((templateIds) => {
        this.subTasksTemplatesRef.$asyncValues(templateIds)
          .then((templates) => {
            this.subtaskTemplates = angular.copy(templates);
            this.subtaskTemplatesCopy = angular.copy(templates);
          })
          .finally(() => {
            this.isLoading = false;
          })
      })
  }

  onToggle(templateId, isSelected) {
    this.onChange({
      templateIds: isSelected ? _.concat(this.selectedIds || [], [templateId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== templateId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;

    this.subtaskTemplatesCopy = this.subtaskTemplates.filter(item =>
      item.title.toLowerCase().includes(query.toLowerCase())
    );

  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({templateIds: []});
    } else {
      this.onChange({templateIds: this.subtaskTemplates.map((t => t.templateId))});
    }
    this.isSelectAll = !this.isSelectAll;
  }
}

angular
  .module('bringoz.admin.sub-tasks')
  .component('subTaskTemplateMultiSelectList', {
    bindings: {
      selectedIds: '<',
      optionIds: '<?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./sub-task-template-multi-select-list.html').default,
    controller: SubTaskTemplateMultiSelectListComponent
  });
